import { SubscribeQuery } from '.';

export const create = (chatId: string, currentUserId: string, text: string, platform: string): any => ({
  className: 'Message',
  chat: {
    __type: 'Pointer',
    className: 'Chat',
    objectId: chatId,
  },
  internalState: 'INITIAL',
  status: 'OUTGOING_CREATED',
  type: 'TEXT',
  text,
  platform,
  salesPerson: {
    __type: 'Pointer',
    className: '_User',
    objectId: currentUserId,
  },
});

export const getAllByChat = (chatId: string): SubscribeQuery => ({
  className: 'Message',
  where: {
    chat: {
      __type: 'Pointer',
      className: 'Chat',
      objectId: chatId,
    },
    isHidden: {
      $ne: true,
    },
  },
  order: '-createdAt',
  limit: 20,
});

const MessageQueries = {
  create,
  getAllByChat,
};

export default MessageQueries;
